export default "__VITE_ASSET__BtccChEZ__"